<template>
  <section
    class="bg-white mx-auto mb-16 px-20 py-12 rounded-lg"
    style="max-width: 800px"
  >
    <form @submit="onSubmit">
      <div class="flex justify-between box-content flex-wrap">
        <Field
          v-slot="{ field, handleChange, errorMessage, meta }"
          name="companyName"
          :validateOnMount="true"
          :validateOnInput="true"
        >
          <BaseTextInput
            name="companyName"
            label="所属企業"
            required
            placeholder="PRONI株式会社"
            :field="field"
            :error-message="errorMessage && meta.dirty ? errorMessage : ''"
            :on-change="handleChange"
            class="w-full mb-9"
          />
        </Field>

        <RegistrationFormParts
          v-for="form in groupFormData"
          :key="form.id"
          :id="'target' + form.id"
          :form="form"
          :errors="errors"
          :hiddenItems="hiddenItems"
          displayGroup="company"
        />
      </div>
      <button
        type="submit"
        class="block mt-3 mb-8 mx-auto font-semibold text-white rounded focus:outline-none h-10"
        :class="[
          Object.keys(errors).length > 0
            ? 'bg-slate-300 cursor-not-allowed'
            : 'bg-coral-main hover:button',
        ]"
        style="width: 200px"
      >
        次へ
      </button>
    </form>
  </section>
</template>

<script>
import { reactive, computed, toRefs } from 'vue';
import { Field, useForm, useFormValues } from 'vee-validate';

import rules from '@/utils/validateRules.js';
import useFormValidation from '@/utils/composables/useFormValidation.js';
import BaseTextInput from '@/components/form/BaseTextInput.vue';
import RegistrationFormParts from '@/views/registration/RegistrationFormParts.vue';

export default {
  components: {
    Field,
    BaseTextInput,
    RegistrationFormParts,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    initialValues: {
      type: Object,
      required: true,
    },
  },
  emits: ['change-view'],
  setup(props, { emit }) {
    const { groupFormData, validationSchema, detectHiddenItems } =
      useFormValidation({
        formData: props.formData,
        inputGroup: 'company',
        initialSchema: {
          companyName(value) {
            const result = rules.validate(value, 'required');
            return result === true || result;
          },
        },
      });

    const { handleSubmit, errors, setFieldError } = useForm({
      initialValues: props.initialValues,
      validationSchema,
      validateOnMount: true,
    });
    const values = useFormValues();

    const state = reactive({
      hiddenItems: computed(() => {
        const hiddenItems = detectHiddenItems(values.value);
        Object.entries(hiddenItems).forEach(([key, value]) => {
          if (value) return;
          setFieldError(`itemId${key}`, '');
        });

        return hiddenItems;
      }),
    });

    const onSubmit = handleSubmit((inputValues) => {
      emit('change-view', { view: 'step2', inputValues });
    });

    return {
      ...toRefs(state),
      groupFormData,
      errors,
      onSubmit,
    };
  },
};
</script>
